<template>
  <div class="col-sm-12">
    <div class="card custom-card">

      <!-- Vehicle Type Dropdown -->
      <div class="form-group">
        <label for="vehicleType" class="block mb-2 font-semibold">
          Vehicle Type : <span class="text-red-500">*</span>
        </label>
        <select
            v-model="vehicleType"
            id="vehicleType"
            class="custom-select"
            :disabled="isSaving"
        >
          <option disabled value="">Select Vehicle Type</option>
          <option v-for="type in vehicleTypeList" :key="type.id" :value="type.id">
            {{ type.vehicle_type }}
          </option>
        </select>
      </div>

      <!-- Vehicle No Input -->
      <div class="form-group">
        <label for="vehicleNo" class="block mb-2 font-semibold">
          Vehicle No : <span class="text-red-500">*</span>
        </label>
        <input
            type="text"
            id="vehicleNo"
            v-model="vehicleNo"
            placeholder="Enter Vehicle No"
            class="name-input"
            :disabled="isSaving"
        />
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-end action-buttons">
        <button
            type="button"
            class="btn btn-danger"
            @click="Cancel"
            :disabled="isSaving"
        >
          Cancel
        </button>
        <button
            type="button"
            class="btn btn-success save-button"
            @click="saveVehicle"
            :disabled="isSaving || !isFormValid"
        >
          <span v-if="!isSaving">Save</span>
          <div v-else class="loading-indicator">
            <span class="spinner"></span>
            <span>Saving...</span>
          </div>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { getVehicleTypeList, saveVehicleDetails } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),
      router: useRouter(),
      vehicleTypeList: [],
      vehicleType: "",
      vehicleNo: "",
      isSaving: false,
    }
  },

  computed: {
    isFormValid() {
      return this.vehicleType && this.vehicleNo.trim();
    }
  },

  created() {
    this.loadVehicleTypeList();
  },

  methods: {
    async loadVehicleTypeList() {
      try {
        const response = await getVehicleTypeList(this.token);
        this.vehicleTypeList = response.data.data || [];
      } catch (error) {
        console.error('Error fetching vehicle type list:', error);
      }
    },

    async saveVehicle() {
      if (!this.vehicleType) {
        useToast().error("Please select a vehicle type.");
        return;
      }

      if (!this.vehicleNo.trim()) {
        useToast().error("Please enter a vehicle number.");
        return;
      }

      this.isSaving = true;
      let idToUse = this.profileId;
      if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
        idToUse = this.reportingProfileId;
      }

      const payload = {
        profile_id: idToUse,
        vehicle_type_id: this.vehicleType,
        vehicle_no: this.vehicleNo,
        is_active: 1,
      };

      try {
        await saveVehicleDetails(this.token, payload);
        useToast().success("Vehicle details added successfully!");
        this.$router.push({ path: "/distributor-vehicles" });
      } catch (error) {
        console.error("Error response:", error.response);
        useToast().error("Failed to save vehicle details. Please try again.");
      } finally {
        this.isSaving = false;
      }
    },

    Cancel() {
      if (!this.isSaving) {
        this.$router.push({ path: "/distributor-vehicles" });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 5px;
  padding: 16px;
}

.custom-select {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.name-input {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.action-buttons {
  padding: 16px;
  gap: 12px;

  .btn {
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    min-width: 100px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.save-button {
  position: relative;
  min-width: 120px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.text-red-500 {
  color: #dc3545;
}

@media (max-width: 768px) {
  .custom-card {
    padding: 16px;
  }

  .form-group {
    padding: 12px;
  }
}
</style>